var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateSkeleton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 202,
    viewBox: "0 0 182 202",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EDEDED",
    strokeLinecap: "square",
    d: "M10.5 101.5h159"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 86)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EDEDED",
    strokeLinecap: "square",
    d: "M6.5 56.5h144M6.5 83.5h144"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#EDEDED",
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 103,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 7)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h31v2H0zM0 31h34v2H0zM0 39h19v2H0zM0 23h24v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 7)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h16v2H0zM0 31h16v2H0zM0 39h16v2H0zM0 23h16v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81 7)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h16v2H0zM0 31h16v2H0zM0 39h16v2H0zM0 23h16v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111 7)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h16v2H0zM0 31h16v2H0zM0 39h16v2H0zM0 23h16v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140 7)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h10v2H0zM0 31h10v2H0zM0 39h10v2H0zM0 23h10v2H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M111 63h16v2h-16zM140 63h10v2h-10zM111 69h16v2h-16zM140 69h10v2h-10zM111 75h16v2h-16zM111 90h16v3h-16zM140 75h10v2h-10zM140 90h10v3h-10z"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#D2D2D2",
    x: -0.5,
    y: -0.5,
    width: 181,
    height: 201,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    width: 160,
    height: 43,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFBFBF",
    cx: 10.5,
    cy: 10.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BFBFBF",
    x: 19,
    y: 9,
    width: 27,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7h20v3H0zM0 19h20v3H0zM0 25h12v2H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125 22h12v2h-12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M6 20h34v2H6zM6 25h24v2H6zM6 30h14v2H6z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 59)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h20v2H0zM0 14h11v2H0zM0 19h7v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53 59)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h20v2H0zM0 14h11v2H0zM0 19h7v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97 59)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h20v2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140 59)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9h20v2H0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateSkeleton);
export default __webpack_public_path__ + "static/media/template-skeleton.90bdeb9987d73413d9aabd208bd309f5.svg";
export { ForwardRef as ReactComponent };